import React from "react";
import {
  DatePickerInput,
  DropDown,
  InputField,
  PhoneInput,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import styles from "./EditProfile.module.css";
import Upload from "../../../../assets/upload.png";
import { Col, Row, Switch } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { roles } from "../../../../config/roles";
import { GrAddCircle } from "react-icons/gr";
import { IoAddCircle, IoCloseCircle } from "react-icons/io5";
import { CalendarIcon } from "../../../../components/icons/Icons";
import Storage from "../../../../utills/AsyncStorage";
import { useDispatch, useSelector } from "react-redux";
import { AuthMiddleware } from "../../../../Store/Middlewares/AuthMiddleware";
import moment from "moment";
import AutoCompleteInput from "../../../../components/auntoCompleteInput/AutoCompleteInput";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import dayjs from "dayjs";

const EditProfile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.AuthReducer.user);
  const urlRegex =
    /(^https?|^http):\/\/www\.?[a-zA-Z0-9.-]+(?:\.[a-zA-Z]{2,})+(?:\/[^\s]*)?$/i;
  const [firstName, setfirstName] = useState(
    user?.first_name ? user?.first_name : null
  );
  const [lastName, setlastName] = useState(
    user?.last_name ? user?.last_name : null
  );
  const [contact, setcontact] = useState(
    user?.contact_no ? user?.contact_no : null
  );
  const [DOB, setDOB] = useState(user?.dob ? user?.dob : null);
  const [email, setemail] = useState(user?.email ? user?.email : null);
  const [address, setaddress] = useState(user?.address ? user?.address : null);
  const [SocialLinks, setSocialLinks] = useState(user?.sociallink);
  const [link, setLink] = useState("");
  const [gender, setgender] = useState(user?.gender ? user?.gender : null);
  const [profile_image, setprofile_image] = useState(
    user?.image ? user?.image : null
  );
  const [currentLocation, setCurrentLocation] = useState();
  const [lat, setlat] = useState(user?.lat);
  const [lng, setlng] = useState(user?.lng);
  console.log("lattttttttttttttttttttttt", DOB);
  console.log("lngggggggggggggggggggg", lng);
  const [coHost, setcoHost] = useState(false);
  const [coHostName, setcoHostName] = useState(null);
  const [coHostEmail, setcoHostEmail] = useState(null);
  const [coHostContact, setcoHostContact] = useState(null);
  const [coHostAddress, setcoHostAddress] = useState(null);

  const hiddenFileInput = React.useRef();
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };
  const [profileImg, setProfileImg] = useState(null);

  const onPressSave = () => {
    if (!firstName || !lastName) {
      dispatch(
        showAlert({
          title: "Name",
          message: "Please enter your full name!",
          type: "Error",
          status: 400,
        })
      );
      return;
    }
    if (contact == "undefined" || !contact) {
      dispatch(
        showAlert({
          title: "Contact No.",
          message: "Please enter valid contact no.",
          type: "Error",
          status: 400,
        })
      );
      return;
    }
    let userData = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      contact_no: contact,
      dob: DOB ? moment(DOB).format("YYYY-MM-DD") : null,
      gender: gender,
      image: profileImg,
      address: currentLocation?.address ? currentLocation?.address : null,
      lat: currentLocation?.lat ? currentLocation?.lat : null,
      lng: currentLocation?.lng ? currentLocation?.lng : null,
    };
    // console.log('userData', userData)
    dispatch(AuthMiddleware.updateClientProfile(userData))
      .then(() => navigate(-1))
      .catch();
  };
  const updateProfile = () => {
    if (!firstName || !lastName) {
      dispatch(
        showAlert({
          title: "Name",
          message: "Please enter your full name!",
          type: "Error",
          status: 400,
        })
      );
      return;
    }
    if (contact == "undefined" || !contact) {
      dispatch(
        showAlert({
          title: "Contact No.",
          message: "Please enter valid contact no.",
          type: "Error",
          status: 400,
        })
      );
      return;
    }
    if (!lat || !lng) {
      dispatch(
        showAlert({
          title: "address",
          message: "Please enter valid address!",
          type: "Error",
          status: 400,
        })
      );
      return;
    }
    let userData = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      contact_no: contact,
      dob: DOB ? moment(DOB).format("YYYY-MM-DD") : null,
      gender: gender?.name,
      image: profileImg ? profileImg : null,
      address,
      lat,
      lng,
      socialLinks: SocialLinks,
    };
    dispatch(AuthMiddleware.updateVendorProfile(userData))
      .then(() => navigate(-1))
      .catch();
  };

  // const role = localStorage.getItem("role");
  const role = Storage.getERole("@role");

  const dropdown_options = [
    { value: "male", option: "male" },
    { value: "female", option: "female" },
  ];

  const onSelectDropdown = (e) => {
    console.log("e", e);
    setgender(e);
  };

  // const onPressSave = () => {
  //   navigate(-1);
  // };

  const onChange = (checked) => {
    console.log(`switch to ${checked}`);
    setcoHost(checked);
  };
  const onChangeDate = (date, dateString) => {
    setDOB(dateString || new Date());
  };

  const handleAddLink = () => {
    if (urlRegex.test(link)) {
      let array = link.split(".");
      let domain = array[array.length - 2];
      SocialLinks.push({ link: link, platform: domain });
      console.log("SocialLinks", SocialLinks);
      setLink("");
      // setrefreshList(!refreshList);
    } else {
      dispatch(
        showAlert({
          title: "Link",
          message: "Please enter valid social link",
          type: "Error",
          status: 400,
        })
      );
    }
    // setSocialLinks([link, ...SocialLinks]);
    // setLink("");
  };

  const handleRemLink = (i) => {
    let links = SocialLinks.filter((item, index) => i != index);
    setSocialLinks(links);
  };
  const editLink = (e) => {};

  console.log("user", user);
  return (
    <div className={styles.main_box}>
      <Row>
        <Col className={styles.sub_div}>
          <InputField
            label={"First Name"}
            placeholder={"Enter first name"}
            value={firstName}
            onChange={(e) => setfirstName(e.target.value)}
            // labelClass={styles.label}
            // styles={styles.input}
          />
          <PhoneInput
            style={{ marginBottom: "20px", backgroundColor: "white" }}
            className={styles.phoneInput}
            value={contact}
            onChange={setcontact}
            label={"Contact Number"}
          />
          {role !== roles.vendor && (
            <DatePickerInput
              onChange={onChangeDate}
              label={"Date of Birth"}
              placeholder={
                DOB ? moment(DOB).format("MM-DD-YYYY") : "Select date"
              }
              format={"MM-DD-YYYY"}
              defaultValue={dayjs(null)}
              // defaultValue={null}
              value= {
                DOB ? 
                dayjs(DOB) : null
              }
              
              icon={<CalendarIcon size={20} />}
            />
          )}
          <InputField
            label={"Email"}
            disabled
            value={email}
            placeholder="Enter email"
            onChange={(e) => setemail(e.target.value)}
            // labelClass={styles.label}
            // styles={styles.input}
          />
          {/* <InputField
            label={"Address"}
            value={address}
            placeholder="Enter address"
            onChange={(e) => setaddress(e.target.value)}
          /> */}
          <AutoCompleteInput
            label={"Location"}
            placeholder={address ? address : "Enter Address"}
            address={address ? address : currentLocation?.adress}
            onSelectPlace={(place) => {
              let currentLocation = {
                lat: place?.geometry?.location?.lat(),
                lng: place?.geometry?.location?.lng(),
                address: place?.formatted_address,
              };
              setCurrentLocation(currentLocation);
              setlat(currentLocation?.lat);
              setlng(currentLocation?.lng);
              setaddress(currentLocation?.address);
            }}
          />

          {role == roles.vendor || role == roles.staff ? (
            <>
              <TextComponent
                text={"Add Social Links"}
                textClass={styles.sub_heading}
              />
              {SocialLinks.map(
                (item, index) => (
                  console.log("item", item),
                  (
                    <InputField
                      value={item?.link}
                      placeholder="Facebook.com/Trish"
                      // onChange={(e)=>{
                      //   let arr = [...SocialLinks]
                      //   arr[index].link= e.target.value;
                      //   setSocialLinks(arr)
                      // }}
                      disabled
                      rightIcon={
                        <IoCloseCircle
                          size={30}
                          className={styles.closeIcon}
                          onClick={() => handleRemLink(index)}
                        />
                      }
                    />
                  )
                )
              )}
              <InputField
                value={link}
                placeholder="Facebook.com/Trish"
                onChange={(e) => setLink(e.target.value)}
                // labelClass={styles.label}
                // styles={styles.input}
                rightIcon={
                  <IoAddCircle
                    size={30}
                    className={styles.addIcon}
                    onClick={handleAddLink}
                  />
                }
              />
            </>
          ) : (
            <></>
          )}
        </Col>

        <Col className={styles.sub_divx}>
          <InputField
            label={"Last Name"}
            placeholder="Enter last name"
            value={lastName}
            onChange={(e) => setlastName(e.target.value)}
            // labelClass={styles.label}
            // styles={styles.input}
          />
          {role !== roles.vendor && (
            <DropDown
              placeholder={"Select gender"}
              label={"Gender"}
              onChange={onSelectDropdown}
              options={dropdown_options}
              selectedValue={gender}
              // labelClass={styles.label}
              // stylesClass={styles.dropdown}
            />
          )}
          <div onClick={handleClick}>
            <img
              src={
                profileImg
                  ? URL.createObjectURL(profileImg)
                  : profile_image
                  ? profile_image
                  : Upload
              }
              className={styles.image}
            />
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setProfileImg(e.target.files[0])}
              ref={hiddenFileInput}
              style={{ display: "none" }}
            />
          </div>
        </Col>
      </Row>

      {/* {role == roles.client ? (
        <div className={styles.co_heading}>
          <TextComponent text={"Add Co-Host"} textClass={styles.sub_heading} />
          <Switch
            defaultChecked={coHost}
            onChange={onChange}
            style={{ backgroundColor: coHost && "var(--primary-color)" }}
          />
        </div>
      ) : null}

      {coHost ? (
        <Row>
          <Col className={styles.sub_div}>
            <InputField
              label={"Name"}
              placeholder="Enter name"
              value={coHostName}
              onChange={(e) => setcoHostName(e.target.value)}
              //   labelClass={styles.label}
              //   styles={styles.input}
            />
            <InputField
              label={"Email"}
              placeholder="Enter email"
              value={coHostEmail}
              onChange={(e) => setcoHostEmail(e.target.value)}
              //   labelClass={styles.label}
              //   styles={styles.input}
            />
            <PhoneInput
              style={{ marginBottom: "20px", backgroundColor: "white" }}
              className={styles.phoneInput}
              value={coHostContact}
              onChange={setcoHostContact}
              label={"Contact Number"}
            />
            <InputField
              label={"Address"}
              value={coHostAddress}
              placeholder="Enter address"
              onChange={(e) => setcoHostAddress(e.target.value)}
              //   labelClass={styles.label}
              //   styles={styles.input}
            />
          </Col>

          <Col className={styles.sub_divx}>
            <img src={Upload} className={styles.image} />
          </Col>
        </Row>
      ) : null} */}

      <SubmitButton
        title={"Save"}
        onClick={
          role == roles.vendor || role == roles.staff
            ? updateProfile
            : onPressSave
        }
        btnClass={styles.button}
      />
    </div>
  );
};

export default EditProfile;
